const styles = theme => ({
  root: {
    width: '100%',
    maxWidth: 1280,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '40px 0 32px',
    marginTop: 40,
  },
  title: {
    fontSize: '24px',
    fontWeight: 500,
    fontFamily: 'Inter',
    fontStyle: 'normal',
    lineHeight: 'normal',
    textAlign: 'center',
    marginBottom: 24,
    background: 'linear-gradient(90deg, #002E47 0%, #015FFB 100%)',
    backgroundClip: 'text',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
  },
  marqueeContainer: {
    width: '100%',
    position: 'relative',
    maskImage: 'linear-gradient(to right, transparent, black 10%, black 90%, transparent)',
    WebkitMaskImage: 'linear-gradient(to right, transparent, black 10%, black 90%, transparent)',
    '&:hover $marqueeGroup': {
      animationPlayState: 'paused',
    },
  },
  marqueeContent: {
    display: 'flex',
    overflow: 'hidden',
    userSelect: 'none',
  },
  marqueeGroup: {
    flexShrink: 0,
    display: 'flex',
    alignItems: 'center',
    gap: 80,
    minWidth: '100%',
    animation: 'marqueeScroll 60s linear infinite',
    paddingLeft: 40,
    paddingRight: 40,
  },
})

export default styles
